import {LoginButtonDefaultBox} from "./login-button.default.box";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {LoginButtonSiBox} from "./login-button.si.box";

export const LoginButtonBox = styledByTheme(LoginButtonDefaultBox).forSI(LoginButtonSiBox).apply();